<template>
  <div id="box">
    <div class="bluebox">
      <div class="bluebox-container">
        <div class="bluebox-text">Get in Touch & Explore New Possibilities</div>
        <div class="bluebox-btn" @click="goToContact">Contact Us</div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-container">
        <div class="footer-left">
          <img
            src="/imgs/start/images/footer-logo_03.png"
            alt="Haili Wind Power Logo"
            class="footer-logo"
          />

          <div class="company-info">
            <div class="company-name">
              JIANGSU HAILI WIND POWER EQUIPMENT TECHNOLOGY CO., LTD.
            </div>
            <div class="company-address">
              Add: No.88, Jinshajiang Road, Rudong Economic Development Zone,
              Jiangsu, China.
            </div>
          </div>
          <div class="social-icons">
            <img
              src="/imgs/start/images/gongzhonghao_03.jpg"
              alt="QR Code"
              class="qr-code"
              @click="showQrCodeDialog"
            />
            <img
              src="/imgs/start/images/in_03.png"
              alt="LinkedIn"
              class="linkedin"
              @click="goToLinkedIn"
            />
          </div>
          <div class="copyright">
            Copyright © Jiangsu Haili Wind Power Equipment Technology Co., Ltd.
            All Rights Reserved.
          </div>
        </div>
        <div class="footer-right">
          <div class="slogan wow fadeInRight" data-wow-delay="0.5s" @click="goToESG">
            <div class="slogan-content">
              <div class="slogan-line1">
                Sustain together, harmonize forever
              </div>
              <div class="slogan-line2">
                Partner up for our nature & humanity
              </div>
            </div>
            <div class="slogan-arrow">
              <img src="/imgs/start/images/jiantou_03.png" alt="Arrow" />
            </div>
          </div>
          <div class="wind-turbines">
            <img
              src="/imgs/start/images/fengcheng_03.png"
              alt="Wind Turbines"
            />
            <img src="/imgs/start/images/sanye1_03.png" alt="" />
            <img src="/imgs/start/images/shanye4_06.png" alt="" />
            <img src="/imgs/start/images/shanye3_03.png" alt="" />
            <img src="/imgs/start/images/shanye4_06.png" alt="" />
          </div>
        </div>
      </div>

      <div class="footer-wave">
        <img src="/imgs/start/bolang_02.png" alt="Wave Background" />
      </div>
    </div>

    <div class="qr-code-overlay" v-if="showQrCode" @click="closeQrCodeDialog">
      <div class="qr-code-dialog" @click.stop>
        <img src="/imgs/start/images/gongzhonghao_03.jpg" alt="QR Code" class="qr-code-large" />
        <div class="qr-code-close" @click="closeQrCodeDialog">×</div>
      </div>
    </div>
  </div>
</template>

<script>
import WOW from "wow.js";
export default {
  components: {},
  data() {
    return {
      showQrCode: false
    };
  },
  created() {},
  mounted() {
    this.initWOW();
  },
  methods: {
    // 初始化 WOW.js 动画
    initWOW() {
      new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 200,
        mobile: true,
        live: true,
      }).init();
    },
    goToContact() {
      this.$router.push('/contact');
    },
    goToESG() {
      this.$router.push('/ESG');
    },
    goToLinkedIn() {
      window.open('https://www.linkedin.com/company/haili-wind-power', '_blank');
    },
    showQrCodeDialog() {
      this.showQrCode = true;
    },
    closeQrCodeDialog() {
      this.showQrCode = false;
    },
  },
};
</script>

<style scoped>
#box {
  font-family: "MiSans-Medium";
}
.bluebox {
  width: 100%;
  background: #003b93;
}
.bluebox-container {
  height: 100px;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5rem;
}
.bluebox-text {
  font-family: "MiSans-Bold";
  font-size: clamp(20px, 2.3vw, 45px);
  /* font-weight: 500; */
  color: #fff;
}
.bluebox-btn {
  width: 185px;
  clip-path: polygon(0 0, calc(100% - 25px) 0, 100% 25px, 100% 100%, 0 100%);
  height: 30px;
  background: #62d476;
  color: #fff;
  font-size: clamp(16px, 1.5vw, 24px);
  font-weight: 500;
  text-align: center;
  line-height: 30px;
  padding: 10px;
  cursor: pointer;
}
.footer {
  background-color: #fff;
  padding: 5rem 0 0;
  position: relative;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 100px;
  /* max-width: 1600px; */
  max-width: 1530px;
  margin: 0 auto;
}

.footer-left {
  flex: 1;
  /* padding-right: 50px; */
}

.footer-logo {
  width: clamp(150px, 15vw, 150px);
  margin-bottom: 20px;
}

.company-info {
  margin-bottom: 20px;
  font-size: clamp(13px, 1.2vw, 18px);
}

.company-name {
  font-weight: 500;
  /* color: #1c4050; */
  margin-bottom: 5px;
  
}
@media (min-width: 1000px) {
  .company-name {
    text-wrap: nowrap;
  }
  /* .company-address{
    text-wrap: nowrap;
  } */
}
.company-address {
  /* color: #1c4050; */
  font-weight: 500;
  line-height: 1.5;
}

.social-icons {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}

.qr-code {
  width: clamp(30px, 5vw, 90px);
  /* height: 50px; */
}

.linkedin {
  width: clamp(30px, 5vw, 80px);
  /* height: 25px; */
}

.copyright {
  font-size: clamp(12px, 1vw, 14px);
  color: #aeb6bb;
}

.footer-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
}

.slogan {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  margin-bottom: 30px;
  animation-direction: 6s;
}

.slogan-content {
  /* text-align: left; */
  font-size: clamp(16px, 1.5vw, 24px);
  font-family: "AlibabaSans-BoldItalic";
  color: #62d476;
  text-wrap: nowrap;
}

.slogan-line1 {
  font-weight: 500;
  margin-bottom: -10px;
}

.slogan-line2 {
  margin-left: 2rem;
}

.slogan-arrow {
  width: 60px;
  height: 60px;
  background-color: #62d476;
  border-radius: 50%;
  color: white;
  font-size: clamp(16px, 1.5vw, 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* font-weight: bold; */
}

.wind-turbines {
  position: relative;
  top: 140px;
  width: 400px;
  height: 300px;
  transform-origin: top center;
}

.wind-turbines img {
  position: absolute;
}

.wind-turbines img:first-child {
  /* 风车杆 */
  position: absolute;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
}

.wind-turbines img:nth-child(2) {
  /* 扇叶1 */
  top: 0px;
  left: 20px;
  z-index: 1;
  transform: translateX(-50%);
  transform-origin: center;
  animation: rotateBladesWithTranslateX 8s linear infinite;
}

.wind-turbines img:nth-child(3) {
  /* 扇叶2 */
  top: 52px;
  left: 76px;
  z-index: 1;
  transform-origin: center;
  animation: rotateBlades 6s linear infinite;
}

.wind-turbines img:nth-child(4) {
  /* 扇叶3 */
  top: -52px;
  left: 237px;
  z-index: 2;
  transform: translateX(-50%);
  transform-origin: center;
  animation: rotateBladesWithTranslateX 5s linear infinite;
}

.wind-turbines img:nth-child(5) {
  /* 扇叶4 */
  scale: 1.3;
  top: 26px;
  left: 315px;
  z-index: 2;
  transform-origin: center;
  animation: rotateBlades 4s linear infinite;
}

.footer-wave {
  width: 100%;
  overflow: hidden;
  position: relative;
  bottom: 0;
  left: 0;
  margin-top: 40px;
  height: 100px;
}

.footer-wave img {
  width: 200%;
  display: block;
  height: auto;
  max-height: 100px;
  position: absolute;
  left: 0;
  bottom: 0;
  animation: waveRoll 15s linear infinite;
}

@keyframes waveRoll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes rotateBlades {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes rotateBladesWithTranslateX {
  from {
    transform: translateX(-50%) rotate(0deg);
  }
  to {
    transform: translateX(-50%) rotate(360deg);
  }
}

/* Responsive styles */
@media (max-width: 1440px) {
  .bluebox-text {
    line-height: 1.3;
  }

  .company-info {
    line-height: 1.5;
  }

  .footer-container {
    padding: 0 10vw;
  }
}

@media (max-width: 1200px) {
  .bluebox-container {
    gap: 3rem;
  }

  .bluebox-text {
    line-height: 1.3;
  }

  .bluebox-btn {
    width: 160px;
    line-height: 1.4;
  }

  .footer-container {
    padding: 0 60px;
  }

  .company-info {
    line-height: 1.5;
  }

  .slogan-content {
    line-height: 1.4;
  }

  .wind-turbines {
    top: 240px;
    width: 400px;
    height: 300px;
    transform: scale(0.75);
    transform-origin: top center;
  }
}

@media (max-width: 1024px) {
  .bluebox-container {
    flex-direction: column;
    gap: 1.5rem;
    height: auto;
    padding: 40px 20px;
  }

  .bluebox-text {
    text-align: center;
    line-height: 1.3;
  }

  .footer-container {
    flex-direction: column;
    text-align: center;
    padding: 0 40px;
  }

  .footer-left {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer-right {
    align-items: center;
    width: 100%;
  }

  .social-icons {
    justify-content: center;
  }

  .slogan {
    justify-content: center;
    margin-bottom: 20px;
    flex-direction: column;
    text-align: center;
  }

  .slogan-content {
    text-align: center;
  }

  .slogan-line2 {
    margin-left: 0;
  }

  .wind-turbines {
    position: static;
    margin-top: 20px;
    /* max-width: 100%; */
    width: 400px;
    height: 300px;
    transform: scale(0.875);
    transform-origin: top center;
  }
}

@media (max-width: 768px) {
  .bluebox-text {
    line-height: 1.3;
  }

  .footer-logo {
    margin-bottom: 20px;
  }

  .company-info {
    text-align: center;
  }

  .company-name {
    margin-bottom: 8px;
  }

  .slogan-content {
    line-height: 1.4;
  }

  .slogan-arrow {
    width: 45px;
    height: 45px;
  }

  .footer-wave {
    margin-top: 30px;
  }

  .wind-turbines {
    width: 400px;
    height: 300px;
    transform: scale(0.75);
    transform-origin: top center;
  }

  /* 恢复原始img定位，通过父容器scale保持相对位置 */
}

@media (max-width: 480px) {
  .bluebox-container {
    padding: 30px 15px;
    gap: 1rem;
  }

  .bluebox-text {
    line-height: 1.4;
  }

  .bluebox-btn {
    width: 140px;
    height: 25px;
    line-height: 25px;
    padding: 8px;
  }

  .footer {
    padding: 3rem 0 0;
  }

  .footer-container {
    padding: 0 20px;
  }

  .footer-logo {
    margin-bottom: 20px;
  }

  .company-info {
    line-height: 1.4;
  }

  .company-address {
    line-height: 1.4;
  }

  .social-icons {
    gap: 10px;
    margin-bottom: 15px;
  }

  .qr-code,
  .linkedin {
    height: auto;
  }

  .slogan {
    gap: 15px;
    margin-bottom: 25px;
  }

  .slogan-content {
    line-height: 1.4;
  }

  .slogan-line2 {
    margin-left: 0;
  }

  .slogan-arrow {
    width: 40px;
    height: 40px;
  }

  .copyright {
    line-height: 1.5;
    padding: 0 10px;
  }

  .footer-wave {
    margin-top: 20px;
    height: 70px;
  }

  .footer-wave img {
    max-height: 70px;
  }

  .wind-turbines {
    width: 400px;
    /* height: 300px; */
    height: 50px;
    transform: scale(0.625);
    transform-origin: top center;
  }

  /* 恢复原始img定位，通过父容器scale保持相对位置 */
}

.qr-code-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.qr-code-dialog {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.qr-code-large {
  width: 300px;
  height: 300px;
  object-fit: contain;
}

.qr-code-close {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  color: #333;
}
</style>